import {IconProps} from "../../types/types";

export default function EmailLineIcon({
    size=24,
    color="black",
    ...props
                                      }:IconProps) {
    return <svg width={size} height={size} {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M3 8.00049L10.8906 13.2609C11.5624 13.7088 12.4376 13.7088 13.1094 13.2609L21 8.00049M5 19.0005H19C20.1046 19.0005 21 18.1051 21 17.0005V7.00049C21 5.89592 20.1046 5.00049 19 5.00049H5C3.89543 5.00049 3 5.89592 3 7.00049V17.0005C3 18.1051 3.89543 19.0005 5 19.0005Z"
            stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>

}